"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _rangeInput = _interopRequireDefault(require("@ux/range-input"));
var _infoTooltip = _interopRequireDefault(require("./info-tooltip"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _debounce = require("../utils/debounce");
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LabelWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LabelWrapper",
  class: "pl-l1fv640s"
});
const Label = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "Label",
  class: "pl-l1b1zqtx"
});
const RangeIndicators = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RangeIndicators",
  class: "pl-rh5r2cy"
});
const RangeInputStyles = "pl-r6p610p";
const logSliderChange = (0, _debounce.debounce)(eventData => {
  (0, _patternLibraryUtils.logEvent)(eventData);
});
const LabeledSlider = ({
  id,
  value,
  title,
  step,
  maxValue,
  minValue,
  onChange,
  tooltipMessage,
  tooltipLabelFormat,
  rangeIndicatorsContent,
  dataCy,
  eid,
  sliderProps
}) => {
  const onSliderChange = (0, _react.useCallback)(currentValue => {
    logSliderChange({
      eid,
      type: 'click',
      properties: {
        value: currentValue
      }
    });
    onChange(currentValue);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": dataCy,
    className: "continuous-slider"
  }, /*#__PURE__*/_react.default.createElement(LabelWrapper, null, /*#__PURE__*/_react.default.createElement(Label, null, /*#__PURE__*/_react.default.createElement("strong", null, title)), /*#__PURE__*/_react.default.createElement(_infoTooltip.default, {
    message: tooltipMessage
  })), /*#__PURE__*/_react.default.createElement(_rangeInput.default, (0, _extends2.default)({
    id: id,
    min: minValue,
    max: maxValue,
    defaultValue: value,
    continuous: true,
    hideTooltip: true,
    tooltipLabelFormat: tooltipLabelFormat,
    onChange: onSliderChange,
    step: step,
    className: RangeInputStyles
  }, sliderProps)), /*#__PURE__*/_react.default.createElement(RangeIndicators, null, rangeIndicatorsContent));
};
LabeledSlider.propTypes = {
  id: _propTypes.default.string,
  step: _propTypes.default.number,
  title: _propTypes.default.string,
  value: _propTypes.default.number,
  minValue: _propTypes.default.number,
  onChange: _propTypes.default.func,
  maxValue: _propTypes.default.number,
  tooltipMessage: _propTypes.default.string,
  tooltipLabelFormat: _propTypes.default.func,
  rangeIndicatorsContent: _propTypes.default.node,
  dataCy: _propTypes.default.string,
  eid: _propTypes.default.string,
  sliderProps: _propTypes.default.shape(_rangeInput.default.propTypes)
};
var _default = exports.default = LabeledSlider;